import React, { Component } from "react";
import { Button, Form, Typography, Input, notification, Spin } from 'antd';
import './forget.module.css'
import { post } from '../../utils/http';
import api from "../../utils/api";
import { LoadingOutlined } from '@ant-design/icons';
import styles from './login.module.css';
import { sessionManager } from "../../core/SessionManager";
import { commonUtil } from '../../utils/commonUtil';

const { Title } = Typography;

class ChangeMobilePwd extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            oldPwd: "",
            newPwd: "",
            confirmPwd: "",
            code:"",
            loading: false,
            disabledSubmit:false
        }
    }

    verifyOTP = () => {
         //verify mobile OTP
         const validData = { "accountId":  sessionManager.getMobileNum(), "detailId": "", "otp": this.state.code, "needChangePassword":false };
         post(api.telepinVerifyTAC, validData).then( response => {
             this.setState({ current: 1  });
             
         }).catch(function (error) {
             if(commonUtil.isJSON(error)){
                 notification['error']({
                     message: JSON.stringify(error.message),
                 });
             }else{
                 notification['error']({
                     message: JSON.stringify(error),
                 });
             }
         })
    }

    handleSubmit = () => {
        const subData = { "oldPassword": this.state.oldPwd, "detailId": sessionManager.getMerchantId(), "newPassword": this.state.newPwd,"confirmPassword":this.state.confirmPwd, "needChangePassword": true };
        this.setState({loading:true});
        post(api.telepinChangePwd, subData).then(response => {
            sessionManager.setMobileNum('');
            this.setState({ current: 2,loading:false});
        }).catch(error => {
            this.setState({loading:false});
            notification['error']({
                message: error,
            });
        })
    }

    goToLogin = () => {
        this.props.history.push("/login");
    }

    getContent = (currentPage) => {
         if (currentPage === 0) {
            //verify OTP after login with temp password
            return (<div>
                        <Form
                            style={{ marginLeft: '100px' }}
                            name="basic"
                            labelCol={{
                                span: 6,
                            }}
                            wrapperCol={{
                                span: 12,
                            }}
                            initialValues={{
                                remember: true,
                            }}
                            autoComplete="off"
                        >
                        <Form.Item label="OTP" name="OTP" rules={[{ required: true, message: 'Please input your OTP!' }]}>
                            <Input  placeholder="Please input OTP" maxLength={6} autoFocus={true} size="large" className={styles.input}  onChange={(event) => this.setState({ code: event.target.value })}/>
                        </Form.Item>

                        <Form.Item
                        wrapperCol={{
                            offset: 4,
                            span: 16,
                        }}>

                        <div>
                            <Button onClick={this.goToLogin} type="primary" htmlType="button" style={{marginRight:'30px'}}>
                                Back
                            </Button>
                            {!this.state.loading && <Button disabled={this.state.disabledSubmit} onClick={this.verifyOTP} type="primary" htmlType="submit">
                                Submit
                            </Button>}
                            {this.state.loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#a52387" }} spin />} />}
                        </div>
                       
                    </Form.Item>
                    </Form>
            </div>
           )
            
        }else if (currentPage === 1) {
            return (<div>
                {/* Mobile user change new password */}
                <p>
                    Please change your password.
                </p>
                <Form
                    style={{ marginLeft: '100px' }}
                    name="basic"
                    labelCol={{
                        span: 6,
                    }}
                    wrapperCol={{
                        span: 12,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Old password"
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your old password!',
                            },
                        ]}
                    >
                        <Input.Password
                            onChange={(event) => this.setState({ oldPwd: event.target.value })}
                            placeholder=""
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="New password"
                        name="new pwd"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your new password!',
                            },
                        ]}
                    >
                        <Input.Password
                            onChange={(event) => this.setState({ newPwd: event.target.value })}
                            placeholder=""
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="Confirm New password"
                        name="confirm pwd"
                        rules={[
                            {
                                required: true,
                                message: 'Please input confirm new password!',
                            },
                        ]}
                    >
                        <Input.Password
                            onChange={(event) => this.setState({ confirmPwd: event.target.value })}
                            placeholder=""
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                            offset: 4,
                            span: 16,
                        }}>

                        <div>
                            <Button onClick={this.goToLogin} type="primary" htmlType="button" style={{marginRight:'30px'}}>
                                Back
                            </Button>
                            {!this.state.loading && <Button disabled={this.state.disabledSubmit} onClick={this.handleSubmit} type="primary" htmlType="submit">
                                Submit
                            </Button>}
                            {this.state.loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#a52387" }} spin />} />}
                        </div>
                       
                    </Form.Item>
                </Form>

            </div>)
        }else  if (currentPage === 2) {
            //mobile user reset password success
            return (<div>
               
                    <p>
                        <b>Change Password Success!</b>  <div></div> <div style={{color:'#1890ff',cursor:'pointer'}} onClick={this.goToLogin} >Login with your password.</div>
                    </p>
                </div>
               )
        }
    }

    render() {
        return (
            <div>
                <div style={{ display: "flex", margin: "0 auto", alignItems: 'center', width: '1100px', height: '600px' }}>
                    <div>
                        <div style={{ height: '350px', width: '1100px', textAlign: 'center', marginTop: 20, padding: 60, fontSize: 18, borderRadius: 2 }} >
                            <Title className={styles.title} style={{ color: "#a52387" }}>DASH Portal</Title>
                            {this.getContent(this.state.current)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ChangeMobilePwd;